import React from "react";
import { Button, Modal, ModalProps } from "semantic-ui-react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

class MessageStartup extends React.Component<ModalProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    dismiss: string[] = [];
    constructor(props: ModalProps) {
        super(props);
        const { cookies, topic } = this.props;
        const cookieString = cookies.get("mv-dismiss");
        this.dismiss = cookieString? cookieString.split(";"): [];
        this.state = {
            visible: !this.dismiss.includes(topic + "_start")
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = (): void => {
        const { cookies, topic } = this.props;
        this.setState({ visible: false });
        const messageId = topic + "_start";
        this.dismiss.push(messageId);
        cookies.set("mv-dismiss", this.dismiss.join(";"), { path: "/", sameSite: "lax" });
    };

    render(): JSX.Element | null {
        if (this.state.visible) {
            let className = "geo-component";
            if (this.props.className) {
                className += " " + this.props.className;
            }
            // quick and dirty!
            const content = <p dangerouslySetInnerHTML={{__html: this.props.content as string}}/>;
            return (
                <Modal
                    className={className}
                    dimmer={"blurring"}
                    open={this.state.visible}
                    onClose={this.handleDismiss}
                >
                    <Modal.Header>{this.props.header}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {content}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.handleDismiss} primary>OK</Button>
                    </Modal.Actions>
                </Modal>
            );
        }

        return null;
    }
}
export default withCookies(MessageStartup);
